import {useCallback} from 'react';
import {TemplateVariable} from 'components/customer/Preview3D/usePreview3DData';
import {ConditionalValues} from 'components/customer/Preview3D/types';
import {use3DContext} from 'components/customer/Preview3D/components/Preview3DComponent';
import {generateDrillingPositions} from 'components/customer/Preview3DCommon/values/drilling';

const useDrillingDynamicValues = () => {
    const {values, productDataStore} = use3DContext();

    const variables: TemplateVariable = JSON.parse(
        productDataStore.current?.template_3d[0].attributes?.variables
    ) as TemplateVariable;

    const getDrillingValues = useCallback(() => {
        return generateDrillingPositions(values);
    }, [values]);

    const drillingValues: ConditionalValues[] = [
        {
            key: 'drilling',
            condition: variables?.hasDrillings,
            callback: getDrillingValues,
        },
    ];

    return {
        drillingValues,
    };
};

export default useDrillingDynamicValues;
